<div class="dialog" [ngClass]="classes" [style.width]="width" [style.height]="height">
  <button *ngIf="disableCloseButton !== true" class="dialog__close" (click)="close()">
    <i class="itvf-close"></i>
  </button>
  <div class="dialog__body" [ngSwitch]="contentType">
    <ng-container *ngSwitchCase="'string'">
      <div [innerHTML]="content"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'template'">
      <ng-container *ngTemplateOutlet="$any(content); context: context"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'component'">
      <ng-container *ngComponentOutlet="$any(content)"></ng-container>
    </ng-container>
  </div>
</div>
